import resouce_download from './resouce_download.vue'
export default {
    resouce_download 
}